// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2wCF_","infoBtn":"quickbooks_infoBtn__3jqU8","formBox":"quickbooks_formBox__2mah0","formFooter":"quickbooks_formFooter__2yz-9"};